// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"67a484bb","130":"d5d238d2","151":"41ff6c44","240":"09356c2b","513":"0dad9209","561":"d875378d","653":"6fc726ee","792":"fed47182","885":"869eeb9a","890":"f52e54e7"}[chunkId] + ".chunk.js";
};